import axios from "axios";
import {BrowserRouter, Routes, Route} from 'react-router-dom' ; 
import { server_host, socket_server } from "../config/server.config";
import { useSelector, useDispatch } from "react-redux";
import { account_user } from "../store/account/selector.account";
import { logout } from "../store/account/actions.account";
import { navigation_data } from "./nav/data.nav";
import ErrorNotFound from "./base/ErrorNotFound";
import UnderConstruction from "./base/UnderConstruction";
import Navigation from "./nav/Nav";
import { useEffect, useState } from "react";
import InfoAccount from "./base/InfoAccount";
import { addRequestStatus, setLoaderStatus } from "../store/global/actions.global";
import Settings from "./settings/Settings";
import { settings_initial_state } from "../config/initials_states";


export interface MainManager {
    settings : boolean
}

export default function Main() {
    // * REDUX HOOKS
    const dispatch = useDispatch()
    const account = useSelector(account_user)
    const server = axios.create({
        baseURL: server_host(),
    });
    const [manager, setManager] = useState({
        settings : settings_initial_state
    })

    // * AXIOS INTERCEPTORS
    server.interceptors.request.use(
        config => {
          const token = account.token;
          if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            config.url += (config?.url?.includes('?') ? '&' : '?') + `token=${account.infos.token_doc}`;
          }
          return config;
        },
        error => {
          return Promise.reject(error);
        }
    );

    // Add a response interceptor to handle 401 Unauthorized errors
    server.interceptors.response.use(
        response => {
            return response;
        },
        error => {   
        if (error.response && error.response.status === 401) {
            dispatch(logout())
            dispatch(addRequestStatus(error.response.data))
        }
        if (!error.response) {
            // Réseau ou autre erreur liée à la requête, mais pas une réponse du serveur
            if (error.message === "Network Error") {
                dispatch(logout())
                dispatch(addRequestStatus({
                    status : false, 
                    message : "Votre token semble être invalide. Veuillez vous reconnecter. "
                }))
            }
        } 
        return Promise.reject(error);
        }
    );

    useEffect(() => {
        // Écoutez l'événement "deposit-status-res" côté client
        socket_server.on('update-loader-message', (data:any) => {
            if([`${account.infos._id}`, 'all'].includes(`${data.user_id}`)) {
                dispatch(setLoaderStatus({status : true, message : data.data}))
            }
        });

        socket_server.on('close-loader', (data) => {
            if([`${account.infos._id}`, 'all'].includes(`${data.user_id}`)) {
                dispatch(setLoaderStatus({status : false}))
            }

        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [socket_server])

    return (
        <BrowserRouter>
            <InfoAccount setManager = {setManager}/>
                {
                    manager.settings ? 
                        <Settings 
                            server = {server} 
                            handleClose = {() => setManager({...manager, settings : false})}    
                        /> 
                    : 
                        null
                }
        <Navigation server = {server} />
          <Routes>
              {
                  navigation_data({account, server}).map(nd => (
                      <Route key = {`Routes-${nd.id}`} path = {nd.path} element = {nd.component ? nd.component : <UnderConstruction />} />   
                  ))
              }
              <Route path = '*' element = {<ErrorNotFound/>} />
          </Routes>
        </BrowserRouter>
    )
}